import { showNotificationWatcher } from 'platform-components/index';

import { redirectToErrorPageWatcher, reportNetworkErrorWatcher } from './defs/network-errors';

export default [redirectToErrorPageWatcher(), reportNetworkErrorWatcher(), showNotificationWatcher()];
